'use client'

import { Menu, MenuButton, MenuItems } from '@headlessui/react'
import { HiEllipsisVertical } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

type Props = {
  buttonSize?: string
  children: React.ReactNode
}

export function DropdownMenu({ buttonSize, children }: Props) {
  return (
    <Menu as='nav' className='relative z-40'>
      <MenuButton className='focus:outline-none'>
        <HiEllipsisVertical className={buttonSize || 'size-6'} aria-hidden={true} />
      </MenuButton>
      <MenuItems
        transition={true}
        modal={false}
        className={twMerge(
          'absolute right-0 z-50 origin-top-right divide-y rounded py-1',
          'border bg-white shadow-lg dark:bg-zinc-800',
          'data-closed:scale-95 data-closed:transform data-closed:opacity-0',
          'focus:outline-none',
        )}
      >
        {children}
      </MenuItems>
    </Menu>
  )
}
